//资源库首页搜索组件
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../../base/BaseComponent";
import {Input, Select, Icon} from 'antd';
import {getInfoFromLocalStorage} from "../../../../../actions";
import {findObject} from "../../../../editor/floatTool/securityCheck";
import MedialSelect from "../../../../editor/toolsSpace/tools/components/medialSelect";
import localUpload from "../../../../editor/toolsSpace/tools/components/img/localUpload.png";
import resourceSelect from "../../../../editor/toolsSpace/tools/components/img/resourceSelect.png";
import CurrencyResourceDialog from "../../dialog/CurrencyResourceDialog";
import {uuid} from "../../../../../utils";
import UploadWall from "../../../../../components/upload/UploadWall";
import {PIC_TYPE} from "../../../../../constants";
import ChunkUpload from "../../../../../components/upload/ChunkUpload";
import {message} from "../../../components/Mess";

const InputGroup = Input.Group;
const {Option} = Select;
const {Search} = Input;

export default class SearchModule extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);

        this.state = {
            tabList: [],
            param: {},
            isHover: "none",
            keyword: '',
            current: '',
            fileList:[]

        };
        this.chunkUpload = new ChunkUpload({
            checkFileURL: "/storage/checkFile",
            checkChunkURL: "/storage/checkChunk",
            uploadChunkURL: "/storage/uploadChunk",
            chunkUploadOverURL: "/storage/chunkIsUploadOver",
            mergeChunksURL: "/storage/mergeChunk"
        });
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getAuthTab();
    }

    render() {
        let data =  JSON.parse(this.sysConfigGetValueByKey("zyk_correct_format", ["jpg", "jpeg", "png", "bmp", "webp", "JPG", "JPEG", "PNG", "BMP", "WEBP"]));
        let accept = "." + data.join(",.");
        let array = JSON.parse(JSON.stringify(accept)).toLowerCase();
        let arr = array.split(",");
        let newArray = [];
        //打开弹框的时候  过滤掉重复的格式
        arr && arr.length && arr.forEach((item, index) => {
            if (newArray.indexOf(item) > -1) {
            } else {
                newArray.push(item)
            }
        });
        newArray = newArray.toString();
        let {tabList,fileList} = this.state;
        return (
            <div id={"Search"} style={{margin: '0 auto', width: '800px', position: "relative",}}>
                <InputGroup compact>
                    <Select
                        getPopupContainer={triggerNode => (triggerNode.parentElement || document.body)}
                        value={this.state.current}
                        style={{width: '12%'}}
                        onChange={(value) => {
                            this.onChange(value)
                        }}>
                        {
                            tabList.map((item) => {
                                return <Option value={item.key} key={item.key}> {item.name}</Option>
                            })
                        }
                    </Select>
                    <Search
                        placeholder="请输入"
                        enterButton="搜索"
                        value={this.state.param?.keyword}
                        size="large"
                        maxLength={50}
                        onChange={(e) => {
                            this.state.param.keyword = e.target.value;
                            this.state.keyword = e.target.value;
                            this.setState({}, () => {

                            })
                        }}
                        onSearch={value => {
                            this.state.param.keyword = value;
                            this.setState({}, () => {
                                if (this.props.type === 'index') {
                                    this.props.showModule && this.props.showModule(this.state.param)
                                } else {
                                    this.props.selectCallBack && this.props.selectCallBack(this.state.param)
                                }
                            })
                        }}
                        suffix={<div style={{height: '30px', marginTop: 10, width: '15px'}} onMouseEnter={() => {
                            this.setState({isHover: "block"})
                        }} onMouseLeave={() => {
                            this.setState({isHover: "none"})
                        }}>
                            <Icon type="camera" style={{fontSize: '20px'}}/>
                            {/*图片下拉框*/}
                            <div key={uuid()} style={{
                                position: 'absolute',
                                top: '32px',
                                right: "-11px",
                                zIndex: 999,
                                display: this.state.isHover
                            }}>
                                <MedialSelect>
                                    <UploadWall
                                        key={this.state.query}
                                        style={{width: "auto", height: '32px'}}
                                        accept={newArray}
                                        multiple={false}
                                        action="/storage/uploadFile"
                                        showUploadBtn={true}
                                        showUploadDisplayBtn={false}
                                        listType="list"
                                        customRequest={this.chunkUpload.start}
                                        beforeUpload={this.beforeUpload}
                                        uploadBtnName={
                                            <div className={'selectList'}
                                                 style={{
                                                     width: '119px',
                                                     height: '32px',
                                                     padding: '0 10px',
                                                     display: "flex",
                                                     alignItems: "center",
                                                 }}>
                                                <img src={localUpload} style={{marginRight: "8px"}}/>
                                                <span>本地上传</span>
                                            </div>
                                        }
                                        onChange={this.handleChange}
                                    />

                                    <div className={'selectList'} onClick={() => this.resourceDialog.show()} style={{
                                        width: '119px',
                                        height: '32px',
                                        padding: '0 10px',
                                        display: "flex",
                                        alignItems: "center",
                                    }}>
                                        <img src={resourceSelect} style={{marginRight: "8px"}}/>
                                        <span style={{color:"rgb(0 0 0 / 65%)"}}>资源库选择</span>
                                    </div>
                                </MedialSelect>
                            </div>
                        </div>}
                        style={{width: '88%'}}
                    />
                    <CurrencyResourceDialog
                        isShowAllPicType={true}
                        onOk={(checkedData) => {
                            if (checkedData && checkedData.length) {
                                this.insertPictureToContent(checkedData)
                            }
                        }}
                        singleChoice={true}
                        ref={resourceDialog => this.resourceDialog = resourceDialog}
                        key={this.state.closeKey}
                        onCloseCall={() => {
                            this.setState({closeKey: uuid()})
                        }}
                    />
                </InputGroup>
                <style>{` #Search  .ant-select-selection{background:#F5F5F5}
                          #Search  .ant-select-selection__rendered {line-height:40px}
                          #Search  .ant-select-selection--single{height:40px}
                          #Search  .ant-input-group-addon{background-color:#0050B3 !important}
                          #Search  .ant-select .ant-select-open .ant-select-focused{height:40px}
                          .ant-select-selection .ant-select-selection--single{height:40px}
                `}</style>
            </div>
        )
    }

    insertPictureToContent(checkedData) {
        this.props.insertPictureToContent && this.props.insertPictureToContent(checkedData, this.state.param);
    }

    setData(data) {
        this.state.param = data;
        this.state.current = data.key;
        this.state.keyword = data.keyword;
        this.setState({})
    };

    //上传之前
    beforeUpload = async file => {
        let data =  JSON.parse(this.sysConfigGetValueByKey("zyk_correct_format", ["jpg", "jpeg", "png", "bmp", "webp", "JPG", "JPEG", "PNG", "BMP", "WEBP"]));
        let res = data.find(item => file.name.endsWith(item));
        let sizeValue = file.size;
        return new Promise((resolve, reject) => {
            if (res) {
                if (sizeValue === 0) {
                    message.error(`空文件不能上传！`);
                    reject();
                } else {
                    resolve()
                }
            } else {
                message.error('暂不支持该文件类型！');
                reject();
            }
        });
    };
    handleChange = info => {
        this.props.localUpload && this.props.localUpload(info, this.state.param);

    };

    onChange(value) {
        let {tabList} = this.state;
        tabList && tabList.length && tabList.forEach(i => {
            if (i.key === value) {
                this.state.param = i
            }
            this.setState({})
        });
        this.state.current = value;
        this.state.param.indexName = value;
        this.state.param.keyword = this.state.keyword;
        this.setState(() => {

            this.props.selectCallBack && this.props.selectCallBack(this.state.param)
        })
    }

    getAuthTab = (callback) => {
        let tabListConfig = JSON.parse(this.sysConfigGetValueByKey("currency.resource.dialog.tab", `
        [
            {"attr":"menuCode", "value":"allResource", "name":"全部资源", "loadDataModule":"allResource","key":"all"},
            {"attr":"menuCode", "value":"publishResource", "name":"公共资源", "loadDataModule":"publishResource","key":"public"},
            {"attr":"menuCode", "value":"unitResources", "name":"单位资源", "loadDataModule":"unitResources","key":"dept"},
            {"attr":"menuCode", "value":"personalResources", "name":"个人资源", "loadDataModule":"personalResources","key":"person"}
        ]`));
        let tabList = [];
        let menu = getInfoFromLocalStorage("menu");
        tabListConfig.map(item => {
            let res = findObject(menu, item.attr, item.value);
            if (res) {

                tabList.push(item);
            }
        });
        if (!tabList[0]?.key) {
            message.warning('请联系管理员增加菜单')
        }
        this.setState({param: tabList[0], tabList: tabList, current: tabList[0]?.key}, () => {
            callback && callback()
    
        })

    };
}
